import React from "react";
import Step1 from "../steps/section-6/step-1";
import Step2 from "../steps/section-6/step-2";
import Step3 from "../steps/section-6/step-3";
import Step4 from "../steps/section-6/step-4";

function TeamReportsSection6({
  step = 1,
  current_year = 0,
  incomeStatement,
  interestExpense = 0,
  data = {},
  teams = {},
  metrics,
  financeRaised = 0,
  returnedToInvestors = 0
}) {
  if (step === 1) {
    return <Step1 />;
  }

  if (step === 2) {
    return (
      <Step2
        data={data}
        teams={teams}
        metrics={metrics}
        financeRaised={financeRaised}
        returnedToInvestors={returnedToInvestors}
      />
    );
  }

  if (step === 3) {
    return (
      <Step3
        incomeStatement={incomeStatement}
        current_year={current_year}
        interestExpense={interestExpense}
      />
    );
  }

  if (step === 4) {
    return (
      <Step4 incomeStatement={incomeStatement} current_year={current_year} />
    );
  }

  return null;
}

export default TeamReportsSection6;



// WEBPACK FOOTER //
// ./src/components/team-reports/sections/section-6.js